import { AppRoute } from 'app/app-layout/constants';
import { NavCategoryId } from 'app/app-layout/models/nav/nav-category-ids.enum';
import { NavItemPrimary } from 'app/app-layout/models/nav/nav-item-primary.model';
import { NavItemSecondary } from 'app/app-layout/models/nav/nav-item-secondary.model';
import { AppScopes } from 'app/core/authentication/models/scopes.enum';

export class AdminNavItem extends NavItemPrimary {
  constructor() {
    super({
      labelId: '$lng_adm_menu_tit6',
      categoryId: NavCategoryId.ADMIN,
      categoryIcon: 'ico-nav-configuration.svg',
      route: AppRoute.administration,
      menuItems: [
        new AdminTrainingNavItem(),
        new AdminEquipmentNavItem(),
        new AdminRecommendationsNavItem(),
        new AdminNotificationsNavItem(),
        new AdminAutoReportNavItem(),
        new AdminAssessmentConfigNavItem(),
        new AdminSiteSettingsNavItem(),
        new AdminImportDataNavItem(),
      ],
    });
  }
}

export class AdminTrainingNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: '$lng_tra_title',
      scopes: [
        AppScopes.TRAINING_CONFIG,
      ],
      route: AppRoute.trainingAdmin,
      categoryId: NavCategoryId.ADMIN,
    });
  }
}

export class AdminEquipmentNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: '$common_equipment',
      scopes: [
        AppScopes.EQUIPMENT_CONFIG,
      ],
      route: AppRoute.equipmentAdmin,
      categoryId: NavCategoryId.ADMIN,
    });
  }
}

export class AdminNotificationsNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: '$common_notifications',
      scopes: [
        AppScopes.NOTIFICATIONS_CONFIG,
      ],
      route: AppRoute.notificationsAdmin,
      categoryId: NavCategoryId.ADMIN,
    });
  }
}

export class AdminAssessmentConfigNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: '$nav_tabs_profile',
      scopes: [
        AppScopes.ASSESSMENT_CONFIG,
      ],
      route: AppRoute.assessments,
      categoryId: NavCategoryId.ADMIN,
    });
  }
}

export class AdminSiteSettingsNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: '$admin_nav_secondary_site_setting',
      scopes: [
        AppScopes.SITE_SETTINGS,
      ],
      route: AppRoute.siteSettings,
      categoryId: NavCategoryId.ADMIN,
    });
  }
}

export class AdminRecommendationsNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: '$evaluation_ergo_recommendations',
      scopes: [
        AppScopes.RECOMMENDATIONS_CONFIG,
      ],
      route: AppRoute.recommendationsAdmin,
      categoryId: NavCategoryId.ADMIN,
    });
  }
}

export class AdminImportDataNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: '$import_menu',
      scopes: [
        AppScopes.IMPORT_DATA_CONFIG,
      ],
      route: AppRoute.importDataAdmin,
      categoryId: NavCategoryId.ADMIN,
    });
  }
}

export class AdminAutoReportNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: '$reports_automated_reports',
      scopes: [
        AppScopes.AUTOMATIC_EMAILS,
      ],
      route: AppRoute.automaticEmails,
      categoryId: NavCategoryId.ADMIN,
    });
  }
}
